import styled from "styled-components";

import { CloseButton as DsCloseButton } from "ds/Button";

export const CloseButton = styled(DsCloseButton)`
  button {
    width: 22px;
    height: 22px;
    svg {
      width: 16.6px !important;
      height: 16.6px !important;
    }
  }
`;

export const BadgeSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const Badge = styled.div`
  box-sizing: border-box;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  padding: 2px 2px 2px 8px;
  white-space: nowrap;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
  background-color: var(--section-snow-background-color, var(--snow));
  color: var(--section-slate-color, var(--slate));
  box-shadow: 0px 1px 4px rgba(152, 160, 171, 0.4);
  border-radius: 2px;
`;
